import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ServiceAddChild from "./ServiceAddChild";

const ServiceAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ServiceAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ServiceAdd;
